<template>
  <div>
    <PlatformFriwa
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      @initialized="platformInitialized"
    ></PlatformFriwa>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformFriwa from '@/device-platforms/PlatformFriwa.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');

export default {
  props: [
    'localStoragePrefix',
    'leiterplattenCodierung',
  ],

  components: {
    PlatformFriwa,
  },

  data: () => ({
    label: 'Bdr Thermea FWS 1.01',
    wasmUrl:'/100001436_Bdr_Thermea_FWS_1d01_P30_SN_MC.wasm',
    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],

    buttons: [
      { platformIndex:  0,conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S1', }, // Pt1000
      { platformIndex:  1,conversion: 'resistorPt1000Temperature', value: null, initialValue: 22.3, name: 'S2', }, // Pt1000
      { platformIndex:  2,conversion: 'resistorPt1000Temperature', value: null, initialValue: 22.3, name: 'S3', }, // Pt1000
      { platformIndex:  3,conversion: 'resistorPt1000Temperature', value: null, initialValue: 22.3, name: 'S4', }, // Pt1000
      { platformIndex:  4,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', }, // Pt1000
      { platformIndex:  5,conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S6', }, // Pt1000
      { platformIndex:  6,conversion: 'voltageVfsFlow', value: null, initialValue: 888.8, name: 'Ga1X', }, // GFA
      { platformIndex:  7,conversion: 'voltageGaTemperature', value: null, initialValue: 888.8, name: 'Ga1T', }, // GFA
      { platformIndex:  8,conversion: 'voltageVfsFlow', value: null, initialValue: 888.8, name: 'Ga2X', }, // GFA
      { platformIndex:  9,conversion: 'voltageGaTemperature', value: null, initialValue: 888.8, name: 'Ga2T', }, // GFA
      { platformIndex:  10,conversion: 'rawFrequency', value: null, initialValue: 0.0, name: 'F1', }, // Frequency
      // { platformIndex: 11,conversion: 'rawFrequency', value: null, initialValue: 12.3, name: 'F2', }, // Frequency
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R3', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R4', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'A1', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      { name: 'A2', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      // { name: 'A3', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'KB' },
      { name: 'UART2', kind: 'VBus', label: 'Modbus' },
    ],

    languages: [
      { value: 0, text: 'Deutsch (de)', short: 'de' },
      { value: 1, text: 'English (en)', short: 'en' },
      { value: 2, text: 'Français (fr)', short: 'fr' },
      { value: 3, text: 'Español (es)', short: 'es' },
      { value: 4, text: 'Italiano (it)', short: 'it' },
      { value: 5, text: 'Svenska (sv)', short: 'sv' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    // async prepareDevice() {
    //   const response = await fetch(this.wasmUrl);
    //   const wasmArrayBuffer = await response.arrayBuffer();
    //   // console.log(wasmArrayBuffer);

    //   this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
    //   // console.log(this.wasmModule);

    //   this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
    //   await this.bridge.instantiate();

    //   this.$refs.platform.prepareBridgeable(() => {
    //     const buffer = Buffer.alloc(1);
    //     buffer [0] = this.leiterplattenCodierung;

    //     const RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG = 0x6d0716a6;
    //     this.bridge.setPlatformConfiguration(RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG, 0, buffer);
    //   });

    //   const vsfResponse = await fetch('/vbus_specification.vsf');
    //   const vsfArrayBuffer = await vsfResponse.arrayBuffer();
    //   const vsfBuffer = Buffer.from(vsfArrayBuffer);
    //   const specificationFile = new SpecificationFile(vsfBuffer);
    //   const specification = new Specification({ specificationFile });
    //   this.vbusSpecifications.push(specification);
    // },


    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();


      // this.$refs.platform.prepareBridgeable(() => {
      //   const buffer = Buffer.alloc(1);
      //   buffer [0] = this.leiterplattenCodierung;

      //   const RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG = 0x6d0716a6;
      //   this.bridge.setPlatformConfiguration(RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG, 0, buffer);
      // });




      let preInitializeCallback = () => {
        // this.bridge.setBiosSdCardRootDir("/ETHERM");
        // this.bridge.setBiosUpdateFilePattern("TEMP????.RSF");


        const buffer = Buffer.alloc(1);
        buffer [0] = this.leiterplattenCodierung;

        const RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG = 0x6d0716a6;
        this.bridge.setPlatformConfiguration(RVM_APPLICATION_CONFIGID_LEITERPLATTENCODIERUNG, 0, buffer);

      };

      // this.$refs.platform.biosCustomizationId = 100000365;
      /*
      */
      this.$refs.platform.prepareBridgeable(preInitializeCallback);
      this.$refs.platform.biosCustomizationId = 100001107;

      {
        const vsfResponse = await fetch('/vbus_specification.vsf');
        const vsfArrayBuffer = await vsfResponse.arrayBuffer();
        const vsfBuffer = Buffer.from(vsfArrayBuffer);
        const specificationFile = new SpecificationFile(vsfBuffer);
        const specification = new Specification({ specificationFile });
        this.vbusSpecifications.push(specification);
      }

      {
        const vsfResponse = await fetch('/VBusSpecification_BdrThermea.vsf');
        const vsfArrayBuffer = await vsfResponse.arrayBuffer();
        const vsfBuffer = Buffer.from(vsfArrayBuffer);
        const specificationFile = new SpecificationFile(vsfBuffer);
        const specification = new Specification({ specificationFile });
        this.vbusSpecifications.push(specification);
        console.log( this. vbusSpecifications );
      }

      {
        const vsfResponse = await fetch('/VBusSpecification_Kaskade.vsf');
        const vsfArrayBuffer = await vsfResponse.arrayBuffer();
        const vsfBuffer = Buffer.from(vsfArrayBuffer);
        const specificationFile = new SpecificationFile(vsfBuffer);
        const specification = new Specification({ specificationFile });
        this.vbusSpecifications.push(specification);
        console.log( this. vbusSpecifications );
      }
    },


    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
